import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/admin/inbox/$leadId")({
  validateSearch: z.object({
    mask: z.string().optional(),
  }),
});
